import { Injectable, Injector, NgZone } from '@angular/core';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { ConfigService } from '../config/config.service';
import { WebcontentService } from '../webcontent/webcontent.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { RedirectService } from '../redirect/redirect.service';
import { UserSessionService } from '../user-session/user-session.service';
import { MobileDataService } from '../mobile-data/mobile-data.service';
import { LoadingController } from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class DeeplinkRedirectService {
  private isAuthenticated: boolean = false;
  private loading: any;
  constructor(
    private zone: NgZone,
    protected config: ConfigService,
    protected injector: Injector,
    public navigator: Navigator,
    public webcontentService: WebcontentService,
    private redirectService: RedirectService,
    private userSessionService: UserSessionService,
    private mobileDataService: MobileDataService,
    public loadingController: LoadingController,
  ) { 
    this.userSessionService.isAuthenticated().then((status) => {
      this.isAuthenticated = status;
     });
  }

  public deeplinksListener() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const url = event.url;
        console.log("url", url);   
        if (url) {                 
          this.checkForRedirects(url);
        }
      });
    });
  }

  private async checkForRedirects(deeplinkUrl) {

    if (deeplinkUrl.indexOf('#password_forgot') > -1 || deeplinkUrl.indexOf('#password_reset') > -1) {
      let twoFactor = this.config.getConfig().FEATURE_MFA_ON_EMAIL ?? 0;

      if(twoFactor == 1 || twoFactor == "1"){
        return this.navigator.navigateTo("ResetPassword2FAComponent", {}, {tokenURL: deeplinkUrl});
      } else {
        return this.navigator.navigateTo("ResetPassword2FAComponent", {}, {tokenURL: deeplinkUrl});
      }
    } else if (deeplinkUrl.includes('#game_launch')) {
      this.redirectService.gameLaunch(deeplinkUrl);
    } else {
    if(!deeplinkUrl.includes('onelink.me')) {
        const { pathname } = new URL(deeplinkUrl);
        const [ , stub, param ] = pathname.split("/");
        this.loading = await this.loadingController.create({
          message: 'Loading...',
          duration: 2000
        });
    
        this.loading.present();
        setTimeout(() => {
          this.deeplinkAction(stub, param);
          this.loading.dismiss();
        }, 2000);
      }  
    }
  }
  
  private deeplinkAction(tabName: string, urlParam?: string): void {
    console.log("deeplinkAction", tabName, urlParam);
    
    switch (tabName) {
      case 'c':
        this.handlePromotionRedirect(urlParam);
        break;
      case 'promotions':
        this.handlePromotionRedirect(tabName);
        break;  

      case 'livedealer':
        this.handleLiveDealerRedirect(tabName);
        break;

      case 'live-dealer':
        this.handleLiveDealerRedirect(tabName);
        break;

      case 'closevip':
        break; //do nothing, stay on the current page
        
      case 'signupstepone':
        if (!this.isAuthenticated) {
          this.navigator.navigateTo('SignupStepOneComponent');
        }
        break;
  
      case 'login':
        if (!this.isAuthenticated) {
          this.navigator.navigateTo('LoginComponent');
        }
        break;

      case 'casino':
        this.handleCasinoRedirect(urlParam);
        break;
      default:
        this.handleCasinoRedirect();
        break;
    }
  }
  
  private handlePromotionRedirect(urlParam?: string): void {
    if (urlParam === 'promotions' || urlParam === 'promos') {
      this.navigator.toTab("casino", true, urlParam);
    } else {
      this.navigator.toWebview(false, urlParam);
    }
    this.mobileDataService.setMobileCasinoDeeplink(urlParam);
  }
  
  private handleLiveDealerRedirect(tabName: string): void {
    if (!this.isAuthenticated) {
      this.navigator.toTab("casino", true, tabName);
    } else {
      this.navigator.toLiveDealer();
    }
    this.mobileDataService.setMobileCasinoDeeplink(tabName);
  }
  
  private handleCasinoRedirect(urlParam?: string): void {
    if (urlParam) {
      this.navigator.toTab("casino", true, urlParam);
      this.mobileDataService.setMobileCasinoDeeplink(urlParam);
    } else {
      this.navigator.toTab("casino", true);
    }
  }
  
}